
import Vue from "vue";
export default Vue.extend({
  props: {
    items: Array<any>,
    loading: Boolean,
    pagination: Object,
    route: String
  },
  data() {
    return {
      headers: [
        { text: "Description", value: "description" },
        { text: "Created Date", value: "createdDate" },
        { text: "Valid From", value: "validFromDate" },
        { text: "Valid To", value: "validToDate" }
      ]
    };
  },
  methods: {
    onItemClick(item: any) {
      this.$emit("click", item);
    },
    onPagination(value: any) {
      this.$emit("update:pagination", value);
    }
  }
});
